<template>
	<TagButtons
		:tags="tags"
		:sport-name="sportName"
		:squared-buttons="squaredButtons"
		:align-buttons="alignButtons"
		@tag-click="tagClicked($event)"
	>
		<template #header>
			<div
				v-if="showHeader"
				class="list--header"
			>
				<img
					v-if="logo"
					:src="logo"
					:alt="title"
				>
				<h3
					class="participant-name"
				>
					{{ title }}
				</h3>
			</div>
		</template>
	</TagButtons>
</template>

<script>
import TagButtons from '@videotools/js/one/components/TagCenter/TagButtons';
export default {
	name:       'ParticipantTags',
	components: { TagButtons },
	props:      {
		tags: {
			type:    Array,
			default: () => [],
		},
		sportName: {
			type:    String,
			default: null,
		},
		squaredButtons: {
			type:    Boolean,
			default: false,
		},
		participant: {
			type: Object,
		},
		alignButtons: {
			type: String,
		},
		showHeader: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		logo() {
			if (!this.participant?.imageUrl) {
				return null;
			}
			return this.$Helpers.getScaledImageUrl(this.participant.imageUrl, 50);
		},
		title() {
			return this.participant.code || this.participant.label;
		},
	},
	methods: {
		tagClicked(tag) {
			this.$emit('tag-click', tag, this.participant);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import "@videotools/sass/_fonts.scss";

.list--header {
	display: flex;
	margin-bottom: 16px;
	align-items: center;
	color: var(--color-soft-white);
	width: 100%;
	@include text-sm-2;

	.participant-name {
		@include text-sm-2(true)
	}

	img {
		width: 24px;
		margin-right: 8px;
	}
}

</style>
